/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface ILicensingClientV1 {

    /**
     * Returns a Pong response.
     * @return Returns a Pong response.
     */
    ping(): Promise<string>;

    /**
     * Retrieve historical (past and present) licenses for a specific company.
     * @param companyId The ID of the company to retrieve historical licenses for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of historical licenses.
     */
    getHistoricalLicensesByCompanyId(companyId: string, pageNumber: number, pageSize: number): Promise<HistoricalLicense[]>;

    /**
     * Retrieve historical (past and present) license user allocations for a specific company.
     * @param companyId The ID of the company to retrieve historical user allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of historical license user allocations.
     */
    getHistoricalUserAllocationsByCompanyId(companyId: string, pageNumber: number, pageSize: number): Promise<HistoricalLicenseUserAllocation[]>;

    /**
     * Create a new license.
     * @param body License to create.
     * @return License created successfully.
     */
    createLicense(body: NewLicenseObject): Promise<License>;

    /**
     * Retrieve all licenses associated with my organization.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of licenses.
     */
    getAllByOrganizationId(companyId: string, pageNumber: number, pageSize: number): Promise<License[]>;

    /**
     * Retrieve a license by its ID.
     * @param licenseId The ID of the license to retrieve.
     * @return License retrieved successfully.
     */
    getLicenseById(licenseId: string): Promise<License>;

    /**
     * Delete a license by its ID.
     * @param licenseId The ID of the license to delete.
     * @return License deleted successfully.
     */
    deleteLicenseById(licenseId: string): Promise<void>;

    /**
     * Update a license by its ID.
     * @param licenseId The ID of the license to update.
     * @param body Updated license data.
     * @return License updated successfully.
     */
    updateLicenseById(licenseId: string, body: UpdateLicenseObject): Promise<License>;

    /**
     * Retrieve all license user allocations for a specific license.
     * @param licenseId The ID of the license to retrieve user allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of license user allocations.
     */
    getLicenseUserAllocations(licenseId: string, pageNumber: number, pageSize: number): Promise<LicenseUserAllocation[]>;

    /**
     * Allocate seats from a license.
     * @param licenseId The ID of the license to allocate user seats from.
     * @param body User to allocate license for
     * @return Seats allocated successfully.
     */
    allocateLicenseUserSeats(licenseId: string, body: LicenseUserAllocationWithoutId[]): Promise<void>;

    /**
     * Deallocate a license seat for a specific user.
     * @param licenseId The ID of the license to deallocate a user seat from.
     * @param userId The ID of the user to deallocate the license seat for.
     * @return License seat deallocated successfully.
     */
    deallocateLicenseUserSeat(licenseId: string, userId: string): Promise<void>;

    /**
     * Update a license user allocation.
     * @param licenseUserAllocationId The ID of the license user allocation to update.
     * @param body Updated license user allocation data.
     * @return License user allocation updated successfully.
     */
    updateLicenseUserAllocation(licenseUserAllocationId: string, body: LicenseUserAllocationUpdate): Promise<void>;

    /**
     * Retrieve all license group allocations for a specific license.
     * @param licenseId The ID of the license to retrieve group allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of license group allocations.
     */
    getLicenseGroupAllocations(licenseId: string, pageNumber: number, pageSize: number): Promise<LicenseGroupAllocation[]>;

    /**
     * Allocate seats from a license.
     * @param licenseId The ID of the license to allocate group seats from.
     * @param body Group to allocate license for
     * @return Seats allocated successfully.
     */
    allocateLicenseGroupSeat(licenseId: string, body: LicenseGroupAllocationWithoutId): Promise<void>;

    /**
     * Deallocate a license seat for a specific user group.
     * @param licenseId The ID of the license to deallocate a group seat from.
     * @param userGroupId The ID of the user group to deallocate the license seat for.
     * @return License seat deallocated successfully.
     */
    deallocateLicenseGroupSeat(licenseId: string, userGroupId: string): Promise<void>;

    /**
     * Retrieve the emails whitelist for a specific license.
     * @param licenseId The ID of the license to retrieve the whitelist for.
     * @return A list of whitelisted emails.
     */
    getLicenseWhitelist(licenseId: string): Promise<WhitelistEntry[]>;

    /**
     * Add emails to the license whitelist.
     * @param licenseId The ID of the license to add emails to the whitelist for.
     * @param body Emails to add to the license whitelist.
     * @return Emails added to whitelist successfully.
     */
    addEmailsToLicenseWhitelist(licenseId: string, body: string[]): Promise<void>;

    /**
     * Remove emails from the license whitelist.
     * @param licenseId The ID of the license to remove emails from the whitelist for.
     * @param body Emails to remove from the license whitelist.
     * @return Emails removed from whitelist successfully.
     */
    removeEmailsFromLicenseWhitelist(licenseId: string, body: string[]): Promise<void>;

    /**
     * Update a license group allocation.
     * @param licenseGroupAllocationId The ID of the license group allocation to update.
     * @param body Updated license group allocation data.
     * @return License group allocation updated successfully.
     */
    updateLicenseGroupAllocation(licenseGroupAllocationId: string, body: LicenseGroupAllocationUpdate): Promise<void>;
}

export class LicensingClientV1 extends JwtApiBase implements ILicensingClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns a Pong response.
     * @return Returns a Pong response.
     */
    ping(): Promise<string> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Retrieve historical (past and present) licenses for a specific company.
     * @param companyId The ID of the company to retrieve historical licenses for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of historical licenses.
     */
    getHistoricalLicensesByCompanyId(companyId: string, pageNumber: number, pageSize: number): Promise<HistoricalLicense[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/historical-licenses?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoricalLicensesByCompanyId(_response);
        });
    }

    protected processGetHistoricalLicensesByCompanyId(response: Response): Promise<HistoricalLicense[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalLicense.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. Pagination parameters are invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve historical licenses for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalLicense[]>(<any>null);
    }

    /**
     * Retrieve historical (past and present) license user allocations for a specific company.
     * @param companyId The ID of the company to retrieve historical user allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of historical license user allocations.
     */
    getHistoricalUserAllocationsByCompanyId(companyId: string, pageNumber: number, pageSize: number): Promise<HistoricalLicenseUserAllocation[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/historical-user-allocations?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoricalUserAllocationsByCompanyId(_response);
        });
    }

    protected processGetHistoricalUserAllocationsByCompanyId(response: Response): Promise<HistoricalLicenseUserAllocation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalLicenseUserAllocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. Pagination parameters are invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve historical user allocations for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalLicenseUserAllocation[]>(<any>null);
    }

    /**
     * Create a new license.
     * @param body License to create.
     * @return License created successfully.
     */
    createLicense(body: NewLicenseObject): Promise<License> {
        let url_ = this.baseUrl + "/licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLicense(_response);
        });
    }

    protected processCreateLicense(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = License.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to create a license for this release channel.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The issuing organization or assigned organization does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(<any>null);
    }

    /**
     * Retrieve all licenses associated with my organization.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of licenses.
     */
    getAllByOrganizationId(companyId: string, pageNumber: number, pageSize: number): Promise<License[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/licenses?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByOrganizationId(_response);
        });
    }

    protected processGetAllByOrganizationId(response: Response): Promise<License[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(License.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve licenses.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License[]>(<any>null);
    }

    /**
     * Retrieve a license by its ID.
     * @param licenseId The ID of the license to retrieve.
     * @return License retrieved successfully.
     */
    getLicenseById(licenseId: string): Promise<License> {
        let url_ = this.baseUrl + "/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenseById(_response);
        });
    }

    protected processGetLicenseById(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = License.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(<any>null);
    }

    /**
     * Delete a license by its ID.
     * @param licenseId The ID of the license to delete.
     * @return License deleted successfully.
     */
    deleteLicenseById(licenseId: string): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLicenseById(_response);
        });
    }

    protected processDeleteLicenseById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to delete this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a license by its ID.
     * @param licenseId The ID of the license to update.
     * @param body Updated license data.
     * @return License updated successfully.
     */
    updateLicenseById(licenseId: string, body: UpdateLicenseObject): Promise<License> {
        let url_ = this.baseUrl + "/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLicenseById(_response);
        });
    }

    protected processUpdateLicenseById(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = License.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid or the request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to update this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. The update could not be completed due to a conflict with the current state of the resource.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(<any>null);
    }

    /**
     * Retrieve all license user allocations for a specific license.
     * @param licenseId The ID of the license to retrieve user allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of license user allocations.
     */
    getLicenseUserAllocations(licenseId: string, pageNumber: number, pageSize: number): Promise<LicenseUserAllocation[]> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/user-allocations?";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenseUserAllocations(_response);
        });
    }

    protected processGetLicenseUserAllocations(response: Response): Promise<LicenseUserAllocation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseUserAllocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve user allocations for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseUserAllocation[]>(<any>null);
    }

    /**
     * Allocate seats from a license.
     * @param licenseId The ID of the license to allocate user seats from.
     * @param body User to allocate license for
     * @return Seats allocated successfully.
     */
    allocateLicenseUserSeats(licenseId: string, body: LicenseUserAllocationWithoutId[]): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/user-allocations";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAllocateLicenseUserSeats(_response);
        });
    }

    protected processAllocateLicenseUserSeats(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid or the request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to allocate seats for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. Not enough available seats or user already has an active license user allocation.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Deallocate a license seat for a specific user.
     * @param licenseId The ID of the license to deallocate a user seat from.
     * @param userId The ID of the user to deallocate the license seat for.
     * @return License seat deallocated successfully.
     */
    deallocateLicenseUserSeat(licenseId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/user-allocations/{userId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeallocateLicenseUserSeat(_response);
        });
    }

    protected processDeallocateLicenseUserSeat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId or userId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to deallocate seats for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID or the user with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. The user does not have an active license user allocation for the specified license.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a license user allocation.
     * @param licenseUserAllocationId The ID of the license user allocation to update.
     * @param body Updated license user allocation data.
     * @return License user allocation updated successfully.
     */
    updateLicenseUserAllocation(licenseUserAllocationId: string, body: LicenseUserAllocationUpdate): Promise<void> {
        let url_ = this.baseUrl + "/license-user-allocations/{licenseUserAllocationId}";
        if (licenseUserAllocationId === undefined || licenseUserAllocationId === null)
            throw new Error("The parameter 'licenseUserAllocationId' must be defined.");
        url_ = url_.replace("{licenseUserAllocationId}", encodeURIComponent("" + licenseUserAllocationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLicenseUserAllocation(_response);
        });
    }

    protected processUpdateLicenseUserAllocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseUserAllocationId is invalid or the request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to update this license user allocation.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license user allocation with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. The update could not be completed due to a conflict with the current state of the resource.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve all license group allocations for a specific license.
     * @param licenseId The ID of the license to retrieve group allocations for.
     * @param pageNumber The page number to retrieve (0-based).
     * @param pageSize The number of items per page.
     * @return A list of license group allocations.
     */
    getLicenseGroupAllocations(licenseId: string, pageNumber: number, pageSize: number): Promise<LicenseGroupAllocation[]> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/group-allocations?";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenseGroupAllocations(_response);
        });
    }

    protected processGetLicenseGroupAllocations(response: Response): Promise<LicenseGroupAllocation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseGroupAllocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve group allocations for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseGroupAllocation[]>(<any>null);
    }

    /**
     * Allocate seats from a license.
     * @param licenseId The ID of the license to allocate group seats from.
     * @param body Group to allocate license for
     * @return Seats allocated successfully.
     */
    allocateLicenseGroupSeat(licenseId: string, body: LicenseGroupAllocationWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/group-allocations";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAllocateLicenseGroupSeat(_response);
        });
    }

    protected processAllocateLicenseGroupSeat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId is invalid or the request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to allocate seats for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. Not enough available seats or group already has an active license group allocation.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Deallocate a license seat for a specific user group.
     * @param licenseId The ID of the license to deallocate a group seat from.
     * @param userGroupId The ID of the user group to deallocate the license seat for.
     * @return License seat deallocated successfully.
     */
    deallocateLicenseGroupSeat(licenseId: string, userGroupId: string): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/group-allocations/{userGroupId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeallocateLicenseGroupSeat(_response);
        });
    }

    protected processDeallocateLicenseGroupSeat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseId or userGroupId is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to deallocate seats for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID or the user group with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. The user group does not have an active license group allocation for the specified license.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the emails whitelist for a specific license.
     * @param licenseId The ID of the license to retrieve the whitelist for.
     * @return A list of whitelisted emails.
     */
    getLicenseWhitelist(licenseId: string): Promise<WhitelistEntry[]> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/whitelist";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenseWhitelist(_response);
        });
    }

    protected processGetLicenseWhitelist(response: Response): Promise<WhitelistEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhitelistEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. License does not have a whitelist.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to retrieve the whitelist for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhitelistEntry[]>(<any>null);
    }

    /**
     * Add emails to the license whitelist.
     * @param licenseId The ID of the license to add emails to the whitelist for.
     * @param body Emails to add to the license whitelist.
     * @return Emails added to whitelist successfully.
     */
    addEmailsToLicenseWhitelist(licenseId: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/whitelist";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEmailsToLicenseWhitelist(_response);
        });
    }

    protected processAddEmailsToLicenseWhitelist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 206) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. License does not have a whitelist.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to modify the whitelist for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Remove emails from the license whitelist.
     * @param licenseId The ID of the license to remove emails from the whitelist for.
     * @param body Emails to remove from the license whitelist.
     * @return Emails removed from whitelist successfully.
     */
    removeEmailsFromLicenseWhitelist(licenseId: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/licenses/{licenseId}/whitelist/remove";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveEmailsFromLicenseWhitelist(_response);
        });
    }

    protected processRemoveEmailsFromLicenseWhitelist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 206) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. License does not have a whitelist.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to modify the whitelist for this license.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a license group allocation.
     * @param licenseGroupAllocationId The ID of the license group allocation to update.
     * @param body Updated license group allocation data.
     * @return License group allocation updated successfully.
     */
    updateLicenseGroupAllocation(licenseGroupAllocationId: string, body: LicenseGroupAllocationUpdate): Promise<void> {
        let url_ = this.baseUrl + "/license-group-allocations/{licenseGroupAllocationId}";
        if (licenseGroupAllocationId === undefined || licenseGroupAllocationId === null)
            throw new Error("The parameter 'licenseGroupAllocationId' must be defined.");
        url_ = url_.replace("{licenseGroupAllocationId}", encodeURIComponent("" + licenseGroupAllocationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLicenseGroupAllocation(_response);
        });
    }

    protected processUpdateLicenseGroupAllocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. The licenseGroupAllocationId is invalid or the request body is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized. Authentication is required and has failed or has not yet been provided.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden. The client does not have access rights to update this license group allocation.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not found. The license group allocation with the specified ID does not exist.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict. The update could not be completed due to a conflict with the current state of the resource.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class LicenseBase implements ILicenseBase {
    releaseChannelId!: string;
    licenseName!: string;
    issuingOrganizationId!: string;
    seats?: number;
    expiresAt?: Date;
    renewalDate!: Date;
    renewalPeriodDays!: number;
    hasWhitelist!: boolean;

    constructor(data?: ILicenseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.licenseName = _data["LicenseName"];
            this.issuingOrganizationId = _data["IssuingOrganizationId"];
            this.seats = _data["Seats"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.renewalDate = _data["RenewalDate"] ? new Date(_data["RenewalDate"].toString()) : <any>undefined;
            this.renewalPeriodDays = _data["RenewalPeriodDays"];
            this.hasWhitelist = _data["HasWhitelist"];
        }
    }

    static fromJS(data: any): LicenseBase {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["LicenseName"] = this.licenseName;
        data["IssuingOrganizationId"] = this.issuingOrganizationId;
        data["Seats"] = this.seats;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["RenewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>undefined;
        data["RenewalPeriodDays"] = this.renewalPeriodDays;
        data["HasWhitelist"] = this.hasWhitelist;
        return data;
    }
}

export interface ILicenseBase {
    releaseChannelId: string;
    licenseName: string;
    issuingOrganizationId: string;
    seats?: number;
    expiresAt?: Date;
    renewalDate: Date;
    renewalPeriodDays: number;
    hasWhitelist: boolean;
}

export class UpdateLicenseObject implements IUpdateLicenseObject {
    seats?: number;
    expiresAt?: Date;

    constructor(data?: IUpdateLicenseObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seats = _data["Seats"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateLicenseObject {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Seats"] = this.seats;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateLicenseObject {
    seats?: number;
    expiresAt?: Date;
}

export class NewLicenseObject extends LicenseBase implements INewLicenseObject {
    assignedOrganizationKey!: string;

    constructor(data?: INewLicenseObject) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assignedOrganizationKey = _data["AssignedOrganizationKey"];
        }
    }

    static fromJS(data: any): NewLicenseObject {
        data = typeof data === 'object' ? data : {};
        let result = new NewLicenseObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssignedOrganizationKey"] = this.assignedOrganizationKey;
        super.toJSON(data);
        return data;
    }
}

export interface INewLicenseObject extends ILicenseBase {
    assignedOrganizationKey: string;
}

export class License extends LicenseBase implements ILicense {
    licenseId!: string;
    assignedOrganizationId!: string;
    allocatedSeats!: number;

    constructor(data?: ILicense) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["LicenseId"];
            this.assignedOrganizationId = _data["AssignedOrganizationId"];
            this.allocatedSeats = _data["AllocatedSeats"];
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseId"] = this.licenseId;
        data["AssignedOrganizationId"] = this.assignedOrganizationId;
        data["AllocatedSeats"] = this.allocatedSeats;
        super.toJSON(data);
        return data;
    }
}

export interface ILicense extends ILicenseBase {
    licenseId: string;
    assignedOrganizationId: string;
    allocatedSeats: number;
}

export class HistoricalLicense implements IHistoricalLicense {
    licenseId!: string;
    releaseChannelId!: string;
    contentMetadataId!: string;
    licenseName!: string;
    issuingOrganizationId!: string;
    assignedOrganizationId!: string;
    startDate!: Date;
    /** The date the license had ended (expired or deleted), null if the license is still active. */
    endDate?: Date;

    constructor(data?: IHistoricalLicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["LicenseId"];
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.licenseName = _data["LicenseName"];
            this.issuingOrganizationId = _data["IssuingOrganizationId"];
            this.assignedOrganizationId = _data["AssignedOrganizationId"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoricalLicense {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalLicense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseId"] = this.licenseId;
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["LicenseName"] = this.licenseName;
        data["IssuingOrganizationId"] = this.issuingOrganizationId;
        data["AssignedOrganizationId"] = this.assignedOrganizationId;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHistoricalLicense {
    licenseId: string;
    releaseChannelId: string;
    contentMetadataId: string;
    licenseName: string;
    issuingOrganizationId: string;
    assignedOrganizationId: string;
    startDate: Date;
    /** The date the license had ended (expired or deleted), null if the license is still active. */
    endDate?: Date;
}

export class HistoricalLicenseUserAllocation implements IHistoricalLicenseUserAllocation {
    licenseAllocationId!: string;
    licenseId!: string;
    licenseName!: string;
    userId!: string;
    createdAt!: Date;
    /** The original expiration date when the allocation was created. */
    originalExpiresAt?: Date;
    /** The current expiration date of the allocation. */
    expiresAt?: Date;
    /** The organization the license was assigned to. */
    assignedOrganizationId!: string;

    constructor(data?: IHistoricalLicenseUserAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseAllocationId = _data["LicenseAllocationId"];
            this.licenseId = _data["LicenseId"];
            this.licenseName = _data["LicenseName"];
            this.userId = _data["UserId"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.originalExpiresAt = _data["OriginalExpiresAt"] ? new Date(_data["OriginalExpiresAt"].toString()) : <any>undefined;
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.assignedOrganizationId = _data["AssignedOrganizationId"];
        }
    }

    static fromJS(data: any): HistoricalLicenseUserAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalLicenseUserAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseAllocationId"] = this.licenseAllocationId;
        data["LicenseId"] = this.licenseId;
        data["LicenseName"] = this.licenseName;
        data["UserId"] = this.userId;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["OriginalExpiresAt"] = this.originalExpiresAt ? this.originalExpiresAt.toISOString() : <any>undefined;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["AssignedOrganizationId"] = this.assignedOrganizationId;
        return data;
    }
}

export interface IHistoricalLicenseUserAllocation {
    licenseAllocationId: string;
    licenseId: string;
    licenseName: string;
    userId: string;
    createdAt: Date;
    /** The original expiration date when the allocation was created. */
    originalExpiresAt?: Date;
    /** The current expiration date of the allocation. */
    expiresAt?: Date;
    /** The organization the license was assigned to. */
    assignedOrganizationId: string;
}

export class LicenseUserAllocationWithoutId implements ILicenseUserAllocationWithoutId {
    userId!: string;
    expiresAt?: Date;
    isPinnedToLicenseExpiration!: boolean;
    isRevoked!: boolean;

    constructor(data?: ILicenseUserAllocationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.isPinnedToLicenseExpiration = _data["IsPinnedToLicenseExpiration"];
            this.isRevoked = _data["IsRevoked"];
        }
    }

    static fromJS(data: any): LicenseUserAllocationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseUserAllocationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["IsPinnedToLicenseExpiration"] = this.isPinnedToLicenseExpiration;
        data["IsRevoked"] = this.isRevoked;
        return data;
    }
}

export interface ILicenseUserAllocationWithoutId {
    userId: string;
    expiresAt?: Date;
    isPinnedToLicenseExpiration: boolean;
    isRevoked: boolean;
}

export class LicenseUserAllocation extends LicenseUserAllocationWithoutId implements ILicenseUserAllocation {
    licenseId!: string;
    licenseUserAllocationId!: string;

    constructor(data?: ILicenseUserAllocation) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["LicenseId"];
            this.licenseUserAllocationId = _data["LicenseUserAllocationId"];
        }
    }

    static fromJS(data: any): LicenseUserAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseUserAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseId"] = this.licenseId;
        data["LicenseUserAllocationId"] = this.licenseUserAllocationId;
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseUserAllocation extends ILicenseUserAllocationWithoutId {
    licenseId: string;
    licenseUserAllocationId: string;
}

export class LicenseUserAllocationUpdate implements ILicenseUserAllocationUpdate {
    expiresAt?: Date;
    isPinnedToLicenseExpiration!: boolean;

    constructor(data?: ILicenseUserAllocationUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.isPinnedToLicenseExpiration = _data["IsPinnedToLicenseExpiration"];
        }
    }

    static fromJS(data: any): LicenseUserAllocationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseUserAllocationUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["IsPinnedToLicenseExpiration"] = this.isPinnedToLicenseExpiration;
        return data;
    }
}

export interface ILicenseUserAllocationUpdate {
    expiresAt?: Date;
    isPinnedToLicenseExpiration: boolean;
}

export class LicenseGroupAllocationWithoutId implements ILicenseGroupAllocationWithoutId {
    userGroupId!: string;
    expiresAt?: Date;
    isPinnedToLicenseExpiration!: boolean;
    isRevoked!: boolean;

    constructor(data?: ILicenseGroupAllocationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.isPinnedToLicenseExpiration = _data["IsPinnedToLicenseExpiration"];
            this.isRevoked = _data["IsRevoked"];
        }
    }

    static fromJS(data: any): LicenseGroupAllocationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseGroupAllocationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["IsPinnedToLicenseExpiration"] = this.isPinnedToLicenseExpiration;
        data["IsRevoked"] = this.isRevoked;
        return data;
    }
}

export interface ILicenseGroupAllocationWithoutId {
    userGroupId: string;
    expiresAt?: Date;
    isPinnedToLicenseExpiration: boolean;
    isRevoked: boolean;
}

export class LicenseGroupAllocation extends LicenseGroupAllocationWithoutId implements ILicenseGroupAllocation {
    licenseId!: string;
    licenseGroupAllocationId!: string;

    constructor(data?: ILicenseGroupAllocation) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["LicenseId"];
            this.licenseGroupAllocationId = _data["LicenseGroupAllocationId"];
        }
    }

    static fromJS(data: any): LicenseGroupAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseGroupAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseId"] = this.licenseId;
        data["LicenseGroupAllocationId"] = this.licenseGroupAllocationId;
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseGroupAllocation extends ILicenseGroupAllocationWithoutId {
    licenseId: string;
    licenseGroupAllocationId: string;
}

export class LicenseGroupAllocationUpdate implements ILicenseGroupAllocationUpdate {
    expiresAt?: Date;
    isPinnedToLicenseExpiration!: boolean;

    constructor(data?: ILicenseGroupAllocationUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.isPinnedToLicenseExpiration = _data["IsPinnedToLicenseExpiration"];
        }
    }

    static fromJS(data: any): LicenseGroupAllocationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseGroupAllocationUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["IsPinnedToLicenseExpiration"] = this.isPinnedToLicenseExpiration;
        return data;
    }
}

export interface ILicenseGroupAllocationUpdate {
    expiresAt?: Date;
    isPinnedToLicenseExpiration: boolean;
}

export class WhitelistEntry implements IWhitelistEntry {
    email!: string;
    createdAt!: Date;

    constructor(data?: IWhitelistEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WhitelistEntry {
        data = typeof data === 'object' ? data : {};
        let result = new WhitelistEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWhitelistEntry {
    email: string;
    createdAt: Date;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */